import React, { useState } from 'react';
import * as Styles from './CreateTicketStep4.style';
import { StepLabel } from 'components/step-label/StepLabel';
import Input from 'components/input';
import { Editable } from '@wysimark/react';
import CustomButton from 'components/common/custom-button/custom-button';
import { Message } from 'components/alert/Message';
import { scrollToSection } from 'utils';
import FormikErrorMessage from 'components/formik-error-message/FormikErrorMessage';
import { Icon } from 'semantic-ui-react';
import { useMutation } from 'react-query';
import { SEARCH } from 'components/support/queries';
import { H5, H6, P } from 'utils/resuable-css';
import axios from 'axios';
import { BASE_URL } from 'constants/env';
import { Base64 } from 'js-base64';
import { useTranslation } from 'react-i18next';

const CreateTicketStep4 = ({
  formikProp,
  loadingCreateTicket,
  searchMacro,
  setSearchMacro,
  macroData,
  setMacroData,
  editor,
}) => {
  const { t } = useTranslation();
  const { values, handleChange, errors, touched, handleBlur, setFieldValue, handleSubmit, validateForm } = formikProp;
  const [searchMacroResult, setSearchMacroResult] = useState({});
  const { mutate: searchMacros } = useMutation(SEARCH);

  const handleMacroSearch = async (text) => {
    setSearchMacro(text);
    await searchMacros(
      {
        searchResult: text,
      },
      {
        onSuccess: (e) => {
          setSearchMacroResult(e);
        },
      },
    );
  };

  const callMacroAPI = async (data) => {
    try {
      const response = await axios.get(BASE_URL + '/admin/kb/macros/' + data.record_id);
      setMacroData(response.data);
      setSearchMacroResult({});
    } catch (error) {}
  };
  const handleCopyMacro = (macro) => {
    setFieldValue('subject', Base64.decode(macro.subject));
    setFieldValue('message', Base64.decode(macro.body));
    // editor.resetMarkdown(Base64.decode(macro.body));
  };

  return (
    <Styles.CreateTicketStep4SC>
      <StepLabel id="ST4" stepCount={'admin/tickets/create.step4_string1'}>
        {t('admin/tickets/create.step4_string2', { name: values.username })}
      </StepLabel>
      <Styles.StepDescription>{t('admin/tickets/create.step4_string3')}</Styles.StepDescription>
      <Styles.SubmitReply>
        <Styles.SearchUsername>
          <Styles.Search>
            <Input
              placeholder={'admin/tickets/create.step4_string4'}
              type="text"
              name={'macro'}
              value={searchMacro}
              onChange={(e) => handleMacroSearch(e.target.value)}
              isFormIk={false}
              EndAdornment={() => (
                <span>
                  <Icon name="search" />
                </span>
              )}
              styling={{ width: '38em' }}
            />
            {searchMacroResult?.results_found === '1' && (
              <Styles.SearchContainer>
                {searchMacroResult?.tickets_users?.results?.map((item, i) => (
                  <div key={i} className="link" onClick={() => callMacroAPI(item)}>
                    <Icon name="circle" />
                    <H6>{item.search_term_en}</H6>
                  </div>
                ))}
              </Styles.SearchContainer>
            )}
          </Styles.Search>
          <Styles.SearchResult>
            {macroData?.macros !== undefined &&
              macroData?.macros?.map((macro, i) => (
                <div key={i}>
                  <H5>{t('admin/tickets/create.step4_string5')}</H5>
                  <div key={i} className="email" onClick={() => handleCopyMacro(macro)}>
                    <Icon name="circle" />
                    <H6>{Base64.decode(macro.subject)}</H6>
                  </div>
                </div>
              ))}
          </Styles.SearchResult>
        </Styles.SearchUsername>
      </Styles.SubmitReply>
      <Styles.Reply>
        <Input
          name={'subject'}
          value={values['subject']}
          placeholder={'admin/tickets/create.step4_string6'}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors['subject']}
          touched={touched['subject']}
          styling={{ width: '100%' }}
        />
        <FormikErrorMessage formikProp={formikProp} value="message" />
        <div style={{ width: '100%' }}>
          <Editable
            value={values.message}
            onChange={() => setFieldValue('message', editor.getMarkdown())}
            editor={editor}
          />
        </div>
        <Styles.TextArea>
          <div className="text">
            <H6 style={{ marginBottom: '10px' }}>
              <strong>{t('admin/tickets/create.step4_string7')}</strong>
            </H6>
            <P>{t('admin/tickets/create.step4_string8')}</P>
          </div>
          <textarea
            name={'secret'}
            value={values['secret']}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors['secret']}
            touched={touched['secret']}
            rows="5"
            placeholder={t('admin/tickets/create.step4_string9')}
          />
        </Styles.TextArea>
        <CustomButton
          type="submit"
          onClick={async () => {
            const errors = await validateForm();
            handleSubmit();
            if (errors.username || errors.emailID) {
              Message.error();
              return scrollToSection('ST1');
            }
            if (errors.dept) {
              Message.error();
              return scrollToSection('ST2');
            }
            if (errors.message || errors.subject) {
              Message.error();
              return scrollToSection('ST4');
            }
          }}
          title={'admin/tickets/create.step4_string10'}
          buttonStyles={{ float: 'right', marginTop: '1em' }}
          isLoading={loadingCreateTicket}
        />
      </Styles.Reply>
    </Styles.CreateTicketStep4SC>
  );
};
export default CreateTicketStep4;
